
import { getProductStocks } from '@pazion/pazion-catalog/src/services/catalog-service';
import { Component, Prop, Vue } from 'vue-property-decorator';
import PazLoader from "@pazion/pazion-core/src/components/utils/PazLoader.vue";

@Component({
  components: {
    PazLoader
  }
})
export default class PazStocksTable extends Vue {

  @Prop() productId!: number
  public loading: boolean = false
  public productStocs = [];

  async mounted() {
    this.loading = true;
    const query = { filter: JSON.stringify({ product: this.productId }), expand: 'warehouse' };
    if (this.productId && this.productStocs.length === 0) {
      const res = await getProductStocks(query);
      if (res)
        this.productStocs = res;
    }
    this.loading = false;
  }
}
